module.exports = __webpack_public_path__ + "highChances.png";